export default __webpack_public_path__ + "static/media/loading.56527739.svg";